/**
 * User avatar color palette (per Leads Upgrade PRD Part 2).
 * Colors are assigned to users in creation order and can be changed
 * from the App Users form.
 */

export const USER_COLOR_PALETTE = [
  '#1976d2', // blue
  '#388e3c', // green
  '#ed6c02', // orange
  '#dc004e', // pink
  '#7b1fa2', // purple
  '#0288d1', // info blue
  '#5d4037', // brown
  '#455a64'  // slate
];

export const defaultColorForIndex = (index) =>
  USER_COLOR_PALETTE[((index % USER_COLOR_PALETTE.length) + USER_COLOR_PALETTE.length) % USER_COLOR_PALETTE.length];

// Deterministic fallback for users whose doc has no color yet
// (backfill runs the first time a super admin opens App Users).
export const fallbackColorForUid = (uid) => {
  if (!uid) return '#9e9e9e';
  let hash = 0;
  for (let i = 0; i < uid.length; i++) {
    hash = (hash * 31 + uid.charCodeAt(i)) | 0;
  }
  return defaultColorForIndex(Math.abs(hash));
};

// First letter of first name + first letter of last name; single letter if one word.
export const getInitials = (name) => {
  if (!name) return '?';
  const words = String(name).trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};
